// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"50e18134","870":"25eb3c6c"}[chunkId] + ".chunk.js";
};